import React, { useMemo } from "react";

/**
 * Pure-CSS drifting particles for login hero.
 * 14 small Sky-blue dots floating upward with randomized timing.
 * Zero JS animation cost — uses CSS keyframes from theme.css (.float-particle).
 * Honors prefers-reduced-motion automatically (CSS rule disables animation).
 */
export function Particles({ count = 14, color = "#1E96FC" }) {
  const dots = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left:    Math.random() * 100,
        size:    2 + Math.random() * 3,           // 2–5px
        delay:   Math.random() * -18,             // -18 → 0 (negative pre-rolls)
        duration: 14 + Math.random() * 12,        // 14–26s
        opacity: 0.18 + Math.random() * 0.35,     // 0.18–0.53
      })),
    [count]
  );

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {dots.map((d) => (
        <span
          key={d.id}
          className="float-particle"
          style={{
            left: `${d.left}%`,
            width: `${d.size}px`,
            height: `${d.size}px`,
            background: color,
            opacity: d.opacity,
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.duration}s`,
          }}
        />
      ))}
    </div>
  );
}

export default Particles;
